module.exports = __webpack_public_path__ + "img/POP-00013-1.6d5bf4fe.png";